import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button } from "antd";
import { DoubleRightOutlined, DownOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  getAllStoreProductInformation,
  getProductInfo,
  getProductPurchaseInfo,
  getProductSaleInfo,
  getProductSalePurchaseInfo,
} from "../../API  Functions/InventoryFunctions";
import dummy_image from "../../assets/Images/gallery.svg";
import ProductPurchaseDetails from "./Tables/ProductPurchaseDetailsTable";
import ProductSaleDetailsTable from "./Tables/ProductSaleDetailsTable";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import SearchBox from "../CustomWidgets/SearchBox";
import AddPackageModal from "../../app/purchase/AddPackageModal";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { toast } from "react-toastify";
import ProductPackages from "./ProductPackages";
import AllStoreProductInfo from "./Tables/AllStoreProductInfoTable";

const { RangePicker } = DatePicker;

const ProductInfo = () => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  const [loading, setloading] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  const [showSale, setShowSale] = useState(false);
  const [isPackageOpen, setIsPackageOpen] = useState(false);

  const [searchid, setsearchid] = useState(localStorage.getItem("searchid"));
  const [prodDetail, setProdDetail] = useState({});
  const [allStoreProdDetail, setAllStoreProdDetail] = useState([]);
  const [purchaseData, setPurchasedata] = useState([]);
  const [saleData, setSaleData] = useState({});
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [dateRange, setDateRange] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [secondBarcode, setSecondaryBarcode] = useState("");

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("Id");

    if (id) {
      localStorage?.setItem("prodId", id);
    }

    const searchparam = id || localStorage.getItem("prodId");
    setsearchid(searchparam);

    if (searchparam) {
      setloading(true);
      GetProductSecondaryCode(searchparam);
      getProdInfo(searchparam);
      getPurchaseInfo(searchparam);
      getAllStoreProductInfo(searchparam);
    }
  }, []);

  const getProdInfo = (searchid) => {
    getProductInfo(company_id, searchid).then((datagot) => {
      setloading(false);
      setProdDetail(datagot?.response);
    });
  };

  const getAllStoreProductInfo = (searchid) => {
    getAllStoreProductInformation(company_id, searchid).then((datagot) => {
      setloading(false);
      console.log("ALL STOREEEE", datagot);

      setAllStoreProdDetail(datagot?.response || []);
    });
  };

  const getPurchaseInfo = (
    searchid
    // startDate = "",
    // endDate = "",
    // venorName = ""
  ) => {
    console.log("SEARCH ID IN PURCHASE INFO", searchid);

    getProductSalePurchaseInfo(
      company_id,
      searchid
      // currentLimit,
      // currentOffset,
      // startDate,
      // endDate,
      // venorName
    ).then((datagot) => {
      console.log("SEARCH ID IN PURCHASE INFO", datagot);

      setloading(false);
      setPurchasedata(datagot?.data || []);
    });
  };

  const handleRangePickerChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      const formattedStart = dayjs(start).format("YYYY-MM-DD");
      const formattedEnd = dayjs(end).format("YYYY-MM-DD");
      setDateRange([formattedStart, formattedEnd]);

      getPurchaseInfo(searchid, formattedStart, formattedEnd);
    } else {
      setDateRange([]);
      getPurchaseInfo(searchid, "", "");
    }
  };

  const handleVendorSearchChange = (value) => {
    setSearchText(value);
    getPurchaseInfo(searchid, dateRange[0], dateRange[1], value);
  };

  const handleCustomerSearchChange = (value) => {
    setSearchText(value);
  };

  const GetProductSecondaryCode = async (id) => {
    const payload = {
      company_id: company_id,
      product_id: Number(id),
      user_id: user_id,
    };
    try {
      const response = await axiosInstance.post(
        URLS.GET_SECONDARY_BARCODE,
        payload
      );
      console.log("GetProductSecondaryCode===>", response);

      if (response?.data?.result[0]?.status_code === 200) {
        setSecondaryBarcode(response?.data?.result[0]?.response[0]?.barcode);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  //   console.log("purchaseData", purchaseData);

  const UpdatePackages = async (prodId, packs) => {
    setloading(true);
    try {
      let payload = {
        product_id: Number(prodId),
        company_id: company_id,
        packages: packs,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_PACKAGE,
        payload
      );
      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result?.status_code == 200) {
        setloading(false);
        //  setIsPackageModalOpen(false);
        toast.success(t("Packs updated successfully"));
      } else {
        toast.error(t(response?.data?.result?.status));
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setloading(false);
    }
  };


const handlePrintLabel = (item) => {
  if (!item) return;

  // === SIZE SETTINGS ===
  const labelWidth = 5;  // cm
  const labelHeight = 2; // cm

  const labelHTML = `
    <div style="
      width: 10cm;
      height: 10cm;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0;
      margin: 0;
      font-family: Arial;
    ">

      <!-- LEFT LABEL -->
      <div style="
        width: ${labelWidth}cm;
        height: ${labelHeight}cm;
        border: 1px dashed #000;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
      ">
        <img 
          src="https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128"
          style="width: 90%; height: 50%; object-fit: contain;"
        />
        <div style="font-size: 10px; font-weight: bold; line-height: 1;">
          ${item.name}
        </div>
        <div style="font-size: 10px;">EGP ${item.sale_price}</div>
        <div style="font-size: 9px; margin-top: 2px;">${item.barcode}</div>
      </div>

      <!-- RIGHT LABEL (same item or blank) -->
      <div style="
        width: ${labelWidth}cm;
        height: ${labelHeight}cm;
        border: 1px dashed #000;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
      ">
        <img 
          src="https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128"
          style="width: 90%; height: 50%; object-fit: contain;"
        />
        <div style="font-size: 10px; font-weight: bold; line-height: 1;">
          ${item.name}
        </div>
        <div style="font-size: 10px;">EGP ${item.sale_price}</div>
        <div style="font-size: 9px; margin-top: 2px;">${item.barcode}</div>
      </div>

    </div>
  `;

  // === CREATE HIDDEN IFRAME ===
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`
    <html>
      <head>
        <style>
          @page {
            size: 10cm 2cm;   /* Full sheet size */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>${labelHTML}</body>
    </html>
  `);
  doc.close();

  // === PRINT AUTOMATICALLY ===
  iframe.contentWindow.focus();
  iframe.contentWindow.print();

  // Clean up
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 1000);
};


  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="inventory" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className="font-extrabold">
                <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    {
                      title: (
                        <Link to={routes.inventory.root}>{t("inventory")}</Link>
                      ),
                      key: "inventory",
                    },
                    { title: t("Product Details") },
                  ]}
                  className="relative mt-3 font-semibold"
                />
              </div>

              <div className="">
                <div className="flex items-center justify-between mt-4 mb-4">
                  <h2 className="text-xl font-bold">{prodDetail?.name}</h2>
                  {/* <RangePicker
                    className="range-picker-placeholder me-4"
                    style={{ minWidth: 220, height: 40 }}
                    placeholder={[t("Start Date"), t("End Date")]}  
                    onChange={handleRangePickerChange}
                  /> */}
                </div>

                <div className="flex flex-col md:flex-row gap-6 items-center bg-white rounded-lg shadow-md p-4">
                  <div className="w-48 h-48 flex items-center justify-center border rounded-lg overflow-hidden">
                    <img
                      src={prodDetail?.image || { dummy_image }}
                      alt={prodDetail?.name}
                      className="object-contain w-full h-full"
                    />
                  </div>

                  <div className="flex flex-col gap-2 text-gray-800">
                    <div className="flex flex-row">
                    <h3 className="text-xl font-semibold">
                      {prodDetail?.name}
                    </h3>

                  {/* <button
  onClick={() => handlePrintLabel(prodDetail)}
                className="w-32 h-8 ms-8 bg-[#7EC242] text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
            >
              Print Label
            </button> */}
  </div>
                    <p>
                      <span className="font-medium">{t("Barcode")}:</span>{" "}
                      {prodDetail?.barcode || "N/A"}
                    </p>
                    {secondBarcode != "" && (
                      <p>
                        <span className="font-medium">
                          {t("Secondary Barcode")}:
                        </span>{" "}
                        {secondBarcode || "N/A"}
                      </p>
                    )}
                    {!allStores && (
                      <p>
                        <span className="font-medium">
                          {t("Current Sale Price")}:
                        </span>{" "}
                        <span className="text-[#F5A623] font-semibold">
                          EGP {prodDetail?.sale_price}
                        </span>
                      </p>
                    )}
                    {!allStores && (
                      <p>
                        <span className="font-medium">{t("In Stock")}:</span>{" "}
                        {prodDetail?.available_qty} {prodDetail?.uom}
                      </p>
                    )}
                    {!allStores && (
                      <p>
                        <span className="font-medium">
                          {t("Current Stock Value")}:
                        </span>{" "}
                        EGP {prodDetail?.current_inventory_value}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {(prodDetail?.uom === "Units" || prodDetail?.uom === "الوحدات") &&
                !allStores && (
                  <div className="mt-6 bg-white rounded-lg flex flex-col items-start">
                    <div className="flex justify-between items-center px-4 ">
                      <button
                        onClick={() => setIsPackageOpen(!isPackageOpen)}
                        className="flex items-center gap-2 text-black px-4 py-4 text-lg font-semibold rounded hover:bg-gray-200 transition-all"
                      >
                        {t("Packages")}
                        <DownOutlined
                          className={`transition-transform duration-300 ${
                            isPackageOpen ? "rotate-180" : "rotate-0"
                          }`}
                        />
                      </button>
                    </div>

                    {isPackageOpen && (
                      <ProductPackages
                        onClose={() => {
                          setIsPackageOpen(false);
                        }}
                        productId={Number(searchid)}
                        savedPackages={null}
                        onSavePackages={UpdatePackages}
                      />
                    )}
                  </div>
                )}

              {allStores && (
                <div className="mt-6 bg-white rounded-lg">
                  <br></br>
                  <div className="font-semibold text-lg ms-5 ">
                    {t("Store-Wise Product Details")}
                  </div>
                  <AllStoreProductInfo
                    additionalData={allStoreProdDetail}
                    handleReferesh={()=>getAllStoreProductInfo(searchid)}
                    // pagination={(values) => {
                    //   setCurrentLimit(values.limit);
                    //   setCurrentOffset(values.offset);
                    //   getAllStoreProductInfo(
                    //     company_id,
                    //     searchid
                    //     // values.limit,
                    //     // values.offset
                    //   );
                    // }}
                  />
                </div>
              )}

              <div className="mt-6 bg-white rounded-lg">
                <br></br>
                <div className="font-semibold text-lg ms-5 ">
                  {t("Sales & Purchases Summary")}
                </div>
                <ProductPurchaseDetails
                  additionalData={purchaseData}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                    getProductSalePurchaseInfo(
                      company_id,
                      searchid
                      // values.limit,
                      // values.offset
                    );
                  }}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductInfo;
